import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/permission-delete.png'


const _hoisted_1 = { class: "pt-8" }
const _hoisted_2 = { class: "header flex items-center justify-end" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "mx-auto",
  alt: "delete"
}, null, -1)
const _hoisted_5 = { class: "w-3/4 mx-auto text-center text-2xl mb-5" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Yakin Akan Hapus Permission ")
const _hoisted_7 = { class: "font-semibold" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" pada Grup User ")
const _hoisted_9 = { class: "font-semibold" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" ? ")
const _hoisted_11 = { class: "flex items-center justify-center gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_Dialog, {
      class: "delete-permission",
      showHeader: false,
      visible: _ctx.showModal,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.showModal = $event)),
      modal: true,
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '30vw' }
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("i", {
              class: "pi pi-times cursor-pointer",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeDialog()))
            })
          ]),
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode("span", _hoisted_7, _toDisplayString(`"${_ctx.permissionName}"`), 1),
              _hoisted_8,
              _createVNode("span", _hoisted_9, _toDisplayString(`"${_ctx.groupName}"`), 1),
              _hoisted_10
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_Button, {
                label: "Batalkan",
                class: "btn-secondary text-black p-button-sm text-base font-bold w-1/2 xl:w-1/4",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeDialog()))
              }),
              _createVNode(_component_Button, {
                label: "Yakin",
                class: "text-white p-button-sm btn-primary w-1/2 xl:w-1/4",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submitData()))
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}